// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__bMDjY","custom-checkbox":"CheckBox_custom-checkbox__sQzxr"};